export const sortTable = (sort) => {
    return (item) => {
        const sortColumnValue = item[sort.column];
        let sortValue;
        switch (sort.dataType) {
            case 'dateField':
                sortValue = new Date(sortColumnValue);
                break;
            default:
                sortValue = sortColumnValue;
        }
        return sortValue;
    };
};
